/**
 * Fixes the import of a module that might be using `export default` or named exports.
 * @todo Figure out why this happens sometimes.
 */
export function fixImport(mod) {
  return "default" in mod ? mod.default : mod;
}
//# sourceMappingURL=fixImport.mjs.map